<mat-card>
  <mat-card-content>
    <app-terms-display
      [type]="'cadPad'"
      [header]="'PAD terms'"
      [message]="'You have a CAD bank account linked to your TUIO account.'"
      [skippable]="skippable"
      (submitted)="submit()"
      (skipped)="skip()">
    </app-terms-display>
  </mat-card-content>
</mat-card>